import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const SectionHeading = ({ index, eyebrow, title, testId }) => (
    <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-gold/90 mb-4">
            {index} — {eyebrow}
        </p>
        <h2
            data-testid={testId}
            className="font-display text-4xl sm:text-5xl font-light tracking-tight text-white max-w-2xl"
        >
            {title}
        </h2>
    </Reveal>
);
